const SAFE_PORTAL_PATHS = new Set([
  "/worker",
  "/managementusa/admin",
  "/managementusa/admin/connections",
  "/colonies",
  "/colonies/tickets",
  "/colonies/managers",
  "/colonies/statement",
]);
const INVOICE_FILE_PATH = /^\/managementusa\/InvoiceFiles\/[A-Za-z0-9_-]{1,160}\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const normalizeTicketId = (value) => {
  const ticketId = String(value || "").trim();
  return /^[A-Za-z0-9_-]{1,160}$/.test(ticketId) ? ticketId : "";
};

export const readTicketParam = (search = window.location.search) => (
  normalizeTicketId(new URLSearchParams(search).get("ticket"))
);

const EXPENSE_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export const readExpenseParam = (search = window.location.search) => {
  const expenseId = String(new URLSearchParams(search).get("expense") || "");
  return EXPENSE_ID.test(expenseId) ? expenseId : "";
};

export const sanitizePortalTarget = (rawTarget) => {
  if (!rawTarget || !String(rawTarget).startsWith("/") || String(rawTarget).startsWith("//")) return "";
  if (String(rawTarget).startsWith("/managementusa/InvoiceFiles/") && !INVOICE_FILE_PATH.test(String(rawTarget).split(/[?#]/, 1)[0])) return "";
  try {
    const parsed = new URL(String(rawTarget), window.location.origin);
    if (parsed.origin !== window.location.origin) return "";
    if (INVOICE_FILE_PATH.test(parsed.pathname) && !String(rawTarget).includes("\\")) return parsed.pathname;
    if (!SAFE_PORTAL_PATHS.has(parsed.pathname)) return "";
    const ticketId = normalizeTicketId(parsed.searchParams.get("ticket"));
    if (ticketId) return `${parsed.pathname}?ticket=${encodeURIComponent(ticketId)}`;
    const expenseId = readExpenseParam(parsed.search);
    return expenseId && ["/worker", "/managementusa/admin"].includes(parsed.pathname) ? `${parsed.pathname}?expense=${expenseId}` : parsed.pathname;
  } catch {
    return "";
  }
};

const targetMatchesHome = (target, home) => {
  if (INVOICE_FILE_PATH.test(target)) return ["/worker", "/managementusa/admin", "/colonies"].includes(home);
  if (home === "/worker") return target.startsWith("/worker");
  if (home === "/managementusa/admin") return target.startsWith("/managementusa/admin");
  if (home === "/colonies") return target.startsWith("/colonies");
  return false;
};

export const portalDestination = (home, nextTarget = "", ticketId = "") => {
  const safeNext = sanitizePortalTarget(nextTarget);
  if (safeNext && targetMatchesHome(safeNext, home)) return safeNext;
  const safeTicketId = normalizeTicketId(ticketId);
  if (!safeTicketId) return home;
  const ticketHome = home === "/colonies" ? "/colonies/tickets" : home;
  return `${ticketHome}?ticket=${encodeURIComponent(safeTicketId)}`;
};

export const managementLoginPath = (destination) => {
  const safeTarget = sanitizePortalTarget(destination);
  return safeTarget ? `/managementusa?next=${encodeURIComponent(safeTarget)}` : "/managementusa";
};

const PENDING_KEY = "managementusa_pending_deep_link";

export const storePendingManagementDeepLink = (deepLink) => {
  try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(deepLink || {})); } catch { /* unavailable */ }
};

export const takePendingManagementDeepLink = () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(PENDING_KEY) || "{}");
    sessionStorage.removeItem(PENDING_KEY);
    return { next: sanitizePortalTarget(saved.next), ticket: normalizeTicketId(saved.ticket) };
  } catch {
    return { next: "", ticket: "" };
  }
};